module.exports = __webpack_public_path__ + "static/Alka1-ddf6977ecdf85afec498c5f095e9cf72.jpg";